import {AfterViewInit, Component, ElementRef, inject, ViewChild} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {StyleClassModule} from 'primeng/styleclass';
import {LayoutService} from '@/layout/service/layout.service';
import {InputText} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {FormsModule} from '@angular/forms';
import {AppSidebar} from './app.sidebar';
import { AppAuthService } from '@/services/app/auth.service';
import { AppNotifications } from "./app.notifications";
import { DialogModule } from 'primeng/dialog';
import { ProfileDialogService } from './profile/profile-dialog.service';
import { FeedbackDialogService } from '../service/feedback-dialog.service';
import * as Sentry from '@sentry/angular';
import { getFeedback } from '@sentry/browser';
import { SearchService } from '@/services/api/search.service';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [
        RouterModule, 
        CommonModule, 
        StyleClassModule, 
        FormsModule, 
        AppSidebar, 
        InputText, 
        ButtonModule, 
        IconField, 
        InputIcon, 
        AppNotifications,
        DialogModule
    ],
    template: `
        <div class="topbar-start">
            <button pButton #menubutton type="button" class="topbar-menubutton p-trigger duration-300" (click)="onMenuButtonClick()">
                <i class="pi pi-bars"></i>
            </button>
        </div>
        <div class="layout-topbar-menu-section">
            <div app-sidebar></div>
        </div>
        <div class="topbar-end">
            <ul class="topbar-menu">
                <li [class]="layoutService.isHorizontal() ? 'topbar-search hidden' : 'topbar-search hidden sm:block'">
                    <p-iconfield>
                        <p-inputicon class="pi pi-search" />
                        <input pInputText type="text" placeholder="{{ searchService.searchPlaceholder }}" class="w-48 sm:w-full" />
                    </p-iconfield>
                </li>
                <li [class]="layoutService.isHorizontal() ? 'block topbar-item' : 'block sm:!hidden topbar-item'">
                    <a pStyleClass="@next" enterFromClass="!hidden" enterActiveClass="animate-scalein" leaveToClass="!hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                        <p-button type="button" icon="pi pi-search" text severity="secondary"></p-button>
                    </a>
                    <ul class="!hidden topbar-menu active-topbar-menu !p-4 w-60 z-5">
                        <p-iconfield class="w-full">
                            <p-inputicon class="pi pi-search" />
                            <input pInputText type="text" placeholder="{{ searchService.searchPlaceholder }}" class="w-full" />
                        </p-iconfield>
                    </ul>
                </li>
                <li class="topbar-item">

                    <button pButton type="button" icon="pi pi-bell" pStyleClass="@next" enterFromClass="!hidden" enterActiveClass="animate-scalein" leaveToClass="!hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true" class="cursor-pointer"></button>
                    <ul [class]="'topbar-menu active-topbar-menu !p-6 w-60 z-50 !hidden'">
                        <app-notifications></app-notifications>
                    </ul>
                </li>
                <li class="topbar-item">
                    <a pStyleClass="@next" enterFromClass="!hidden" enterActiveClass="animate-scalein" leaveToClass="!hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true" class="cursor-pointer">
                        <img class="rounded-xl w-8 h-8" [src]=" authService.userImage() || '/images/generic.jpg'" alt="Profile" />
                    </a>
                    <ul [class]="'topbar-menu active-topbar-menu !p-6 w-60 z-50 !hidden'">
                        <li role="menuitem" class="!m-0 !mb-4">
                            <a
                                (click)="onSettingsItemClick()"
                                class="cursor-pointer flex items-center hover:text-primary-500 duration-200"
                                pStyleClass="@grandparent"
                                enterFromClass="!hidden"
                                enterActiveClass="animate-scalein"
                                leaveToClass="!hidden"
                                leaveActiveClass="animate-fadeout"
                                [hideOnOutsideClick]="true"
                            >
                                <i class="pi pi-fw pi-cog mr-2"></i>
                                <span>Settings</span>
                            </a>
                        </li>
                        <li role="menuitem" class="!m-0">
                            <a
                                (click)="loginOrLogout()"
                                class="cursor-pointer flex items-center hover:text-primary-500 duration-200"
                                pStyleClass="@grandparent"
                                enterFromClass="!hidden"
                                enterActiveClass="animate-scalein"
                                leaveToClass="!hidden"
                                leaveActiveClass="animate-fadeout"
                                [hideOnOutsideClick]="true"
                            >
                                <i [class]="authService.isAuthenticated() ? 'pi pi-fw pi-sign-out mr-2' : 'pi pi-fw pi-sign-in mr-2'"></i>
                                <span>{{ authService.isAuthenticated() ? 'Logout' : 'Login' }}</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="topbar-item">

                    <button pButton type="button" icon="pi pi-question-circle" pStyleClass="@next" enterFromClass="!hidden" enterActiveClass="animate-scalein" leaveToClass="!hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true" class="cursor-pointer"></button>
                    <ul [class]="'topbar-menu active-topbar-menu !p-6 w-60 z-50 !hidden'">
                        <li role="menuitem" class="!m-0 !mb-4">
                            <a
                                id="feedback-button"
                                class="cursor-pointer flex items-center hover:text-primary-500 duration-200"
                                pStyleClass="@grandparent"
                                enterFromClass="!hidden"
                                enterActiveClass="animate-scalein"
                                leaveToClass="!hidden"
                                leaveActiveClass="animate-fadeout"
                                [hideOnOutsideClick]="true"
                            >
                                <i class="pi pi-fw pi-comment mr-2"></i>
                                <span>Feedback</span>
                            </a>
                        </li>
                        <li role="menuitem" class="!m-0">
                            <a
                                (click)="openDocs()"
                                class="cursor-pointer flex items-center hover:text-primary-500 duration-200"
                                pStyleClass="@grandparent"
                                enterFromClass="!hidden"
                                enterActiveClass="animate-scalein"
                                leaveToClass="!hidden"
                                leaveActiveClass="animate-fadeout"
                                [hideOnOutsideClick]="true"
                            >
                                <i class="pi pi-fw pi-book mr-2"></i>
                                <span>Help Center</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    `,
    host: {
        class: 'layout-topbar'
    }
})
export class AppTopbar implements AfterViewInit {
    layoutService = inject(LayoutService);
    authService = inject(AppAuthService);
    searchService = inject(SearchService);
    el = inject(ElementRef);
    profileDialogService = inject(ProfileDialogService);
    feedbackDialogService = inject(FeedbackDialogService);
    showSettings = false;

    showFeedbackWidget = false;

    docsLink = 'https://docs.lexarlearning.com/s/03b9d306-5985-4ffe-93aa-66ae64211d9f';

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild(AppSidebar) appSidebar!: AppSidebar;

    ngAfterViewInit(): void {
        const feedback = getFeedback();
        const button = document.getElementById('feedback-button');
    
        if (feedback && button) {
          feedback.attachTo(button, {
            formTitle: 'Send Feedback'
          });
        } else {
          console.warn('Sentry Feedback integration not available.');
        }
      }

    loginOrLogout() {
        if (this.authService.isAuthenticated()) {
            this.authService.logout();
        } else {
            this.authService.login();
        }
    }


    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onConfigButtonClick() {
        this.layoutService.toggleConfigSidebar();
    }

    onSettingsItemClick() {
        this.profileDialogService.toggleSettings();
    }

    openFeedbackWidget() {
        this.feedbackDialogService.openFeedback();
    }

    openDocs() {
        window.open(this.docsLink, '_blank');
    }
}